import styled from 'styled-components'

export const AccountContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 1rem 0.5rem 0.5rem 0.5rem;
`

export const AccountContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`
